import api from './index'

export function getHeadAdmins(params) {
  return api.get('/api/v1/admin-users/hq', { params })
}

export function createHeadAdmin(data) {
  return api.post('/api/v1/admin-users/hq', data)
}

export function updateHeadAdmin(adminUserCode, data) {
  return api.put(`/api/v1/admin-users/hq/${adminUserCode}`, data)
}

export function updateHeadAdminPassword(adminUserCode, data) {
  return api.post(`/api/v1/admin-users/hq/${adminUserCode}/password`, data)
}

export function deleteHeadAdmin(adminUserCode) {
  return api.delete(`/api/v1/admin-users/hq/${adminUserCode}`)
}
